export default "__VITE_ASSET__8d54d57f__"